import { PageContainer, IPageContainerProps } from "./PageContainer";

export type { IPageContainerProps };
export default PageContainer;
